export enum NotificationsHubEvents {
    LoadNavbarNotifications = "LoadNavbarNotifications",
    ReceiveMessage = "ReceiveMessage"
}
